<script setup>
import { ref, reactive, computed, onMounted, nextTick } from "vue";
import { queryDictData } from "@/api/common";
import {
  getOpKnowledgeBaseCategoryTreeApi,
  saveOpKnowledgeBaseArticle,
  updateArticleInfoApi,
} from "@/api/article";
import { ElMessage } from "element-plus";
import { fileUploadApi } from "@/api/common";
import Editor from "../../plantConfig/editor.vue";

const emits = defineEmits(["afterSave"]);

// 弹窗控制
const visible = ref(false);

// 弹窗类型
const dialogType = ref("add");

const titleType = reactive({
  add: "新增",
  edit: "编辑",
  info: "查看",
});

// api
const requestApi = reactive({
  add: saveOpKnowledgeBaseArticle,
  edit: updateArticleInfoApi,
});

// 树props
const defaultProps = reactive({
  label: "name",
  children: "childNodes",
});

// 区域树
const treeData = ref([]);

// 获取树
const getDirectoryTree = () => {
  getOpKnowledgeBaseCategoryTreeApi()
    .then((res) => {
      treeData.value = res.data;
    })
    .finally(() => {});
};

// 表单ref
const ruleRef = ref(null);

// 类型列表
const areaTypeList = ref([]);

// 弹窗loading
const loading = ref(false);

onMounted(async () => {
  getDirectoryTree();
});

// 表单
const formData = reactive({
  categoryId: null,
  title: null,
  content: null,
  isCommonProblem: "0",
});

// 表单校验
const rules = reactive({
  categoryId: [
    { required: true, message: "父目录不能为空", trigger: "change" },
  ],
  title: [{ required: true, message: "文章标题", trigger: "blur" }],
  content: [{ required: true, message: "文章内容不能为空", trigger: "blur" }],
});

// 点击保存
const formSubmit = () => {
  if (formData.content == "<p><br></p>") {
    formData.content = "";
  }
  ruleRef.value?.validate((valid) => {
    if (valid) {
      console.log(requestApi[dialogType.value]);
      requestApi[dialogType.value](formData).then((res) => {
        if (res.code == "2000") {
          ElMessage.success("操作成功");
          visible.value = false;
          emits("afterSave");
        }
      });
    }
  });
};

// 弹窗打开
const handleDialogOpen = (data, type) => {
  ruleRef.value?.resetFields();
  visible.value = true;
  dialogType.value = type;
  nextTick(() => {
    if (type == "edit" || type == "info") {
      for (const key in formData) {
        formData[key] = data[key];
      }
      formData.id = data.id;
    }
  });
};

// 函数暴露给父组件调用
defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog
    :title="titleType[dialogType]"
    v-model="visible"
    width="50%"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleRef"
      :model="formData"
      :rules="rules"
      label-width="80px"
      v-loading="loading"
    >
      <el-row>
        <el-col>
          <el-form-item label="父目录" prop="categoryId">
            <el-tree-select
              check-strictly
              v-model="formData.categoryId"
              :data="treeData"
              :render-after-expand="false"
              :props="defaultProps"
              node-key="id"
              :disabled="dialogType === 'info'"
              style="width: 300px"
            />
            <el-checkbox
              style="margin-left: 10px"
              v-model="formData.isCommonProblem"
              :true-label="1"
              :false-label="0"
              label="设置为常见问题"
              :disabled="dialogType === 'info'"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="标题" prop="title">
            <el-input
              v-model="formData.title"
              placeholder="请输入标题（最多50个字）"
              :disabled="dialogType === 'info'"
              maxlength="50"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="内容" prop="content">
            <editor ref="myQuillEditor" v-model:content="formData.content" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <span class="dialog-footer" v-if="dialogType !== 'info'">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="formSubmit()"> 保存 </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<style lang="scss">
.tox-tinymce-aux {
  z-index: 9999 !important;
}
</style>
